import { render, staticRenderFns } from "./ModalRetakeTest.vue?vue&type=template&id=115d2dae"
import script from "./ModalRetakeTest.vue?vue&type=script&lang=ts"
export * from "./ModalRetakeTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports